import React from 'react';

const constants = {
    // "opas": "https://passports.go.ug",
    // "opas_start": "https://passports.go.ug/start",

    "url": "https://passports.go.ug/ctd/api",
    "auth_url": "https://passports.go.ug/ctd/auth/",

    "opas": "https://passports.go.ug",
    "opas_start": "https://passports.go.ug/start",
}



export default constants;
